import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDownLeftAndArrowUpRightToCenter } from '@fortawesome/sharp-solid-svg-icons/faArrowDownLeftAndArrowUpRightToCenter';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'ui-components/components/button';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFrameworkMethodsPropType } from 'ui-components/prop-types/modal-framework-methods';
import { CustomerRecords } from '../../containers/customer-records-container/components/customer-records';
import Global from '../../../../store/global-selectors';
import * as Actions from '../../../../store/customers/combine/customers.combine.actions';

import messages from './messages';
import style from './combine-customers-modal.module.less';

const CombineCustomersModal = ({ modalFrameworkMethods }) => {
  const { closeModal } = modalFrameworkMethods;
  const dispatch = useDispatch();

  const customersCount = useSelector((state) => Global.selectSelectedCustomersCount(state) || 0);

  const handleCombinebuttonClick = useCallback(() => {
    dispatch(Actions.prepareToOpenCombineCustomersConfirmationModal());
  }, [dispatch]);

  return (
    <Modal className={style['combine-customers-modal']} size='medium'>
      <ModalHeader className={style['combine-customers-modal-header']} closeModal={closeModal}>
        <FormattedMessage {...messages.title} />
      </ModalHeader>
      <ModalBody className={style['combine-customers-modal-body']}>
        <FormattedMessage {...messages.body} />
        <hr className={style['combine-customers-section-divider']} />
        <CustomerRecords />
      </ModalBody>
      <ModalFooter className={style['combine-customers-modal-footer']}>
        <Button onClick={closeModal} theme='tertiary'>
          <FormattedMessage {...messages.cancel} />
        </Button>
        <Button disabled={!!(customersCount < 2)} onClick={handleCombinebuttonClick} theme='primary'>
          <div className={style['combine-button']}>
            <FontAwesomeIcon className={style.combine} icon={faArrowDownLeftAndArrowUpRightToCenter} />
            <FormattedMessage {...messages.combine} />
          </div>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

CombineCustomersModal.propTypes = {
  modalFrameworkMethods: ModalFrameworkMethodsPropType.isRequired,
};

export default CombineCustomersModal;
